import { styles } from './Dashboard.styles';

export const DashboardLoading = () => (
	<>
		<header className={styles.topbar}>
			<div className="h-md w-[96px] animate-pulse rounded bg-grey-25" />
			<div className="h-md w-[128px] animate-pulse rounded bg-grey-25" />
		</header>
		<main className={styles.content}>
			<div className="flex flex-col gap-xs">
				<div className="h-sm w-[128px] animate-pulse rounded bg-grey-25" />
				<div className="h-[28px] w-[192px] animate-pulse rounded bg-grey-25" />
				<div className="h-md w-[288px] animate-pulse rounded bg-grey-25" />
			</div>
			<div className={styles.statGrid}>
				{['a', 'b', 'c', 'd', 'e'].map((k) => (
					<div key={`stat-${k}`} className="flex flex-col gap-xs">
						<div className="h-sm w-[80px] animate-pulse rounded bg-grey-25" />
						<div className="h-[28px] w-[64px] animate-pulse rounded bg-grey-25" />
						<div className="h-sm w-[96px] animate-pulse rounded bg-grey-25" />
					</div>
				))}
			</div>
		</main>
	</>
);
